import React from "react";
import { ConfigProvider } from "antd";
import "./App.css";
import "antd/dist/antd.variable.min.css";
import locale from "antd/lib/locale/ar_EG";
import { initializeApp } from "firebase/app";
import { QueryClient, QueryClientProvider } from "react-query";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import PrivacyPolicy from "./pages/PrivacyPolicy";

const firebaseConfig = {
  apiKey: "AIzaSyB7PxvIm8Mz3elFCRDH-6t1BTFnOaehbRc",
  authDomain: "sabi-13f6d.firebaseapp.com",
  projectId: "sabi-13f6d",
  storageBucket: "sabi-13f6d.appspot.com",
  messagingSenderId: "703577444663",
  appId: "1:703577444663:web:99f8150dedceeafef14ab2",
  measurementId: "G-LMR0XWEE38",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const queryClient = new QueryClient();
const router = createBrowserRouter([
  {
    path: "/",
    element: <PrivacyPolicy />,
    errorElement: <div>Error</div>,
  },
]);
ConfigProvider.config({
  theme: {
    primaryColor: "#009bbb",
  },
});
const App = () => {
  return (
    <ConfigProvider
      direction="rtl"
      locale={locale}
      theme={{
        token: {
          colorPrimary: "#009bbb",
          fontFamily: "MyFont",
        },
      }}
    >
      <QueryClientProvider client={queryClient}>
        <div>
          <RouterProvider router={router} />
        </div>
      </QueryClientProvider>
    </ConfigProvider>
  );
};

export default App;
